import { useDispatch, useSelector } from 'react-redux'

import type { Title } from '../../pages/SearchPage/useMentorsSearch'
import {
  addToFavorites,
  getFavoriteMentors,
  getFeaturedMentorPage,
  getFeaturedMentors,
  getFeaturedMentorsChunks,
  getIsSearchingMentors,
  getIsSearchingTitles,
  getSelectedMentors,
  getTitles,
  removeFromFavorites,
  setFavoriteMentors,
  setFeaturedMentorPage,
  setFeaturedMentors,
  setFeaturedMentorsChunks,
  setIsSearchingMentors,
  setIsSearchingTitles,
  setSelectedMentor,
  setTitles,
} from '../../store/reducers/mentorsReducer'
import { AppDispatch } from '../../store/store'
import { MentorBase } from '../../types/mentor'

export const useMentorsState = () => {
  const dispatch: AppDispatch = useDispatch()

  const isSearchingMentors = useSelector(getIsSearchingMentors)
  const isSearchingTitles = useSelector(getIsSearchingTitles)
  const selectedMentor = useSelector(getSelectedMentors)
  const favoriteMentors = useSelector(getFavoriteMentors)
  const titles = useSelector(getTitles)
  const featuredMentorsChunks = useSelector(getFeaturedMentorsChunks)
  const featuredMentors = useSelector(getFeaturedMentors)
  const featuredMentorPage = useSelector(getFeaturedMentorPage)

  return {
    isSearchingMentors,
    isSearchingTitles,
    selectedMentor,
    favoriteMentors,
    titles,
    featuredMentorsChunks,
    featuredMentors,
    featuredMentorPage,
    setIsSearchingMentors: (isSearching: boolean) =>
      dispatch(setIsSearchingMentors(isSearching)),
    setIsSearchingTitles: (isSearching: boolean) =>
      dispatch(setIsSearchingTitles(isSearching)),
    setSelectedMentor: (mentor: MentorBase | null) =>
      dispatch(setSelectedMentor(mentor)),
    setFavoriteMentors: (mentors: string[]) =>
      dispatch(setFavoriteMentors(mentors)),
    addToFavorites: (mentorId: string) => dispatch(addToFavorites(mentorId)),
    removeFromFavorites: (mentorId: string) =>
      dispatch(removeFromFavorites(mentorId)),
    setTitles: (t: Title[]) => dispatch(setTitles(t)),
    setFeaturedMentorsChunks: (mentors: MentorBase[][]) =>
      dispatch(setFeaturedMentorsChunks(mentors)),
    setFeaturedMentors: (mentors: MentorBase[]) =>
      dispatch(setFeaturedMentors(mentors)),
    setFeaturedMentorPage: (page: number) =>
      dispatch(setFeaturedMentorPage(page)),
  }
}
